"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areObjectsEqual = void 0;
var areObjectsEqual = function (first, second) {
    return JSON.stringify(first) === JSON.stringify(second);
};
exports.areObjectsEqual = areObjectsEqual;
